"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

require("./buttons.sass");

var Buttons = function Buttons(_ref) {
  var className = _ref.className,
      primary = _ref.primary,
      flat = _ref.flat,
      small = _ref.small,
      borderless = _ref.borderless,
      props = (0, _objectWithoutProperties2.default)(_ref, ["className", "primary", "flat", "small", "borderless"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)('btns', {
      'btn--primary': primary,
      'btn--small': small,
      'btn--flat': flat,
      'btn--borderless': borderless
    }, className)
  }, props));
};

Buttons.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes.default.string,
  small: _propTypes.default.bool,
  flat: _propTypes.default.bool,
  borderless: _propTypes.default.bool
} : {};
var _default = Buttons;
exports.default = _default;